import { JwtHighbondClient } from '@acl-services/jwt-highbond-client';
import config from './config';

export const client = new JwtHighbondClient({
  tokenRefreshUrl: config.tokenRefreshUrl,
  autoRedirect: true,
  loginUrl: config.loginUrl,
});
